import React, { ReactNode } from 'react';
import {
  Breadcrumbs,
  ButtonProps,
  Header as SatoHeader,
  LinkButton,
} from '@sato/components';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

import { Link, LinkProps } from './common/Link';

export interface HeaderProps {
  title: string;
  subHeading?: string;
  breadcrumbs?: LinkProps[];
  children?: ReactNode;
  className?: string;
  backLink?: LinkProps;
  cta?: ButtonProps<typeof Link>;
  leadText?: string;
}

export const Header = ({
  title,
  breadcrumbs,
  children,
  subHeading,
  className,
  cta,
  leadText,
  backLink,
}: HeaderProps) => (
  <header className={twMerge('w-full', className)}>
    {breadcrumbs || backLink || children ? (
      <div
        className={classNames(
          'flex flex-col gap-4 py-3',
          'container-margin-wide'
        )}
      >
        {breadcrumbs && (
          <Breadcrumbs links={breadcrumbs} linkComponent={Link} />
        )}

        {backLink && (
          <LinkButton
            {...backLink}
            linkComponent={Link}
            variant="text"
            className="!text-inherit"
            icon="arrowLeft"
          />
        )}

        {children && <div className="pb-3">{children}</div>}
      </div>
    ) : null}

    <SatoHeader
      heading={title}
      leadText={leadText}
      subHeading={subHeading}
      className="antialiased"
    />

    {cta && (
      <div className="container-margin-wide">
        <LinkButton
          variant="filled"
          linkComponent={Link}
          {...cta}
          className={twMerge(cta.className, 'mt-4')}
        />
      </div>
    )}
  </header>
);
